import { Component } from '@angular/core';

import { TabNode } from '../insight/experimental.tabset';

@Component({
    selector: '[cmpsInsightExplorerTabHover]',
    template: ` <div>
        <span>{{ tab?.def.ctx.label }}</span>
    </div>`,
})
export class TabHoverInsightExplorerComponent {
    tab: TabNode;
}
